import CloseController from '../../controllers/CloseController';
import QuestDailyController from '../../controllers/quest/QuestDailyController';
import { QuestClaim } from './QuestClaim';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import QuestClaimController from '../../controllers/quest/QuestClaimController';
import { QuestPageClaimedMobileGrid } from './QuestPageClaimedMobileGrid';
import { DailyQuestMobile } from './DailyQuestMobile';

export const QuestPageClaimMobile = {
	name: COMPONENTS.QUEST_PAGE_CLAIM,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: QuestDailyController,
			name: 'QuestDailyController',
			config: {
				item: 'quest_daily',
				val: 'quest_daily',
			}
		},
		{
			Controller: MainGridController,
			name: 'QuestPageClaimedMobileGrid',
			config: QuestPageClaimedMobileGrid
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 1,
				item: 'quest_claim_1',
				color: 'rgba(113, 178, 238, 1)',
				img: 'quest_reward_icon_1'
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 2,
				item: 'quest_claim_2',
				color: 'rgba(183, 238, 113, 1)',
				img: 'quest_reward_icon_2'
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 3,
				item: 'quest_claim_3',
				color: 'rgba(183, 113, 238, 1)',
				img: 'quest_reward_icon_5'
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 4,
				item: 'quest_claim_4',
				color: 'rgba(238, 113, 173, 1)',
				img: 'quest_reward_icon_4'
			}
		}
	],
	components: [
		{
			name: 'quest_page_main_bg',
			type: 'Sprite',
			img: 'settings_page_main_bg',
			position: { x: 0, y: 0 },
			alpha: 0.95
		},
		{
			name: 'header',
			type: 'CustomText',
			text: 'QUEST_DAILY_HEADER',
			position: { x: 0, y: 0 }
		},
		{
			name: 'close',
			type: 'Button',
			components: [
				{
					name: 'bg',
					type: 'MouseOverSprite',
					img: 'close_icon',
					imgHover: 'close_icon_hovered',
					position: { x: 0, y: -10 }
				}
			]
		},
		{
			name: 'quest_daily',
			position: { x: 53, y: 0 },
			type: 'VisualComponent',
			component: DailyQuestMobile
		},
		{
			name: 'quest_claim_1',
			position: { x: 58, y: 306 },
			type: 'VisualComponent',
			component: QuestClaim
		},
		{
			name: 'quest_claim_2',
			position: { x: 323, y: 306 },
			type: 'VisualComponent',
			component: QuestClaim
		},
		{
			name: 'quest_claim_3',
			position: { x: 586, y: 306 },
			type: 'VisualComponent',
			component: QuestClaim
		},
		{
			name: 'quest_claim_4',
			position: { x: 850, y: 306 },
			type: 'VisualComponent',
			component: QuestClaim
		},
	]
};
